import React, { FunctionComponent } from 'react';
import useGlobalClass from '../../hooks/useGlobalClass';

const NotFoundPage: FunctionComponent = () => {
    useGlobalClass('with-navigation');
    return <h3>Not found</h3>;
};

export default NotFoundPage;
